<template>
	<component :is="component" v-if="component" :data="data" :visible="visible" :ready="ready" />
</template>

<script>
import FlexibleContentBlockBase from 'dc-vue-default/src/components/FlexibleContentBlockBase'
import _ from 'lodash/debounce';

export default {
	extends: FlexibleContentBlockBase,
	computed: {
		loader() {
			if (!this.type) {
				return null
			}
			if ([
				'CookiebotConsentPage',
				'Slider',
			].includes(this.type)) {
				return () => import(`DcVueCookiebot/components/blocks/${this.type}`)
			}
			return () => import(`./${this.componentFolder}/${this.type}`)
		},
	},
	mounted() {
		this.loader()
			.then(() => {
				this.component = () => this.loader()
			})
			.catch(() => {
				this.component = false
			})
	}
}
</script>